import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import PoLinePhysical from '../entities/receive-physicals/receive-physical';
interface ReceivePhysicalState extends ListState<PoLinePhysical>{
   
}

class ReceivePhysicalModule extends ListModule<ReceivePhysicalState, any, PoLinePhysical>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<PoLinePhysical>(),
        loading: false
    }
    actions={
        async getPoLinePhysicals(context:ActionContext<ReceivePhysicalState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Po/GetPoLinePhysicals',{params:payload.data});
            context.state.loading=false;
            // let page=reponse.data.result as PageResult<PoLinePhysical>;
            // context.state.totalCount=page.totalCount;
            // context.state.list=page.items;
            return reponse.data.result;
        },
        async receivePhysicalItem(context: ActionContext<ReceivePhysicalState, any>, payload: any) {
            await Ajax.put('/api/services/app/Po/ReceivePhysicalItem', payload.data);
        },
    }
}
const receivePhysicalModule=new ReceivePhysicalModule();
export default receivePhysicalModule;